import { render, staticRenderFns } from "./NaviBarSbrand.vue?vue&type=template&id=78a906b8&scoped=true&"
import script from "./NaviBarSbrand.vue?vue&type=script&lang=js&"
export * from "./NaviBarSbrand.vue?vue&type=script&lang=js&"
import style0 from "./NaviBarSbrand.vue?vue&type=style&index=0&id=78a906b8&prod&lang=scss&scoped=true&"
import style1 from "./NaviBarSbrand.vue?vue&type=style&index=1&id=78a906b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a906b8",
  null
  
)

export default component.exports